export default __webpack_public_path__ + "static/media/172.4646ce68.jpg";